export enum PermissionsEnum {
  None = 0,
  CanBrowseUsers = 10,
  CanViewUser = 11,
  CanEditUser = 12,
  CanAddUser = 13,
  CanBrowseRoles = 14,
  CanViewRole = 15,
  CanEditRole = 16,
  CanAddRole = 17,
  CanDeleteRole = 18,
  CanBrowseTeams = 19,
  CanViewTeam = 20,
  CanEditTeam = 21,
  CanAddTeam = 22,
  CanDeleteTeam = 23,
  CanViewSettings = 24,
  CanEditSettings = 25,
  CanManageWalletsService = 26,
  CanViewUserSessions = 27,
  CanDeleteUserSessions = 28,
  CanViewUserStatistics = 29,
  CanBrowseUserTeams = 30,
  CanEditUserTeams = 31,
  CanBrowseCountries = 32,
  CanRemoveUserTeams = 33,
  CanViewUsers = 34,
  CanEditPausedAutoassignments = 35,
  CanViewCountryConfiguration = 36,
  CanEditCountryConfiguration = 37,
  CanViewPaymentControls = 38,
  CanEditDaxQueries = 39,
  CanForceLogoutClient = 58,
  CanBrowseClients = 100,
  CanMakeTransfers = 101,
  CanViewClientInformation = 102,
  CanViewClientDocuments = 103,
  CanViewClientContact = 104,
  CanViewClientTickets = 105,
  CanViewClientTests = 106,
  CanViewClientIBInformation = 107,
  CanViewClientClassification = 108,
  CanViewClientOtherInformation = 109,
  CanViewClientWalletsAccounts = 110,
  CanViewPaymentNotes = 111,
  CanEditPaymentNotes = 112,
  CanEditClient = 113,
  CanEditClientStatus = 114,
  CanAddClient = 115,
  CanAddClientRestriction = 116,
  CanEditClientRestriction = 117,
  CanDeleteClientRestriction = 118,
  CanViewClientRestriction = 119,
  CanBrowseClientRestrictions = 120,
  CanAddClientNotes = 121,
  CanEditClientNotes = 122,
  CanDeleteClientNotes = 123,
  CanBrowseClientNotes = 124,
  CanViewClientNotes = 125,
  CanViewClientAccountStatistics = 126,
  CanViewClientAccountTransactions = 127,
  CanAddClientDocuments = 128,
  CanEditClientDocuments = 129,
  CanDeleteClientDocuments = 130,
  CanVerifyDocuments = 131,
  CanAddClientTests = 132,
  CanAddClientIBInformation = 133,
  CanAddClientClassification = 134,
  CanViewClientPowerOfAttorney = 135,
  CanAcceptClientPowerOfAttorney = 136,
  CanEditClientOtherInformation = 137,
  CanVerifyClientIdentity = 138,
  CanActivateClient = 139,
  CanRequestEmailClientDocuments = 140,
  CanViewClientAccessLog = 141,
  CanViewClientAuditTrail = 142,
  CanChangeClientTestStatus = 143,
  CanViewTickmillCompanyClassificationConfiguration = 144,
  CanChangeTickmillCompanyClassificationConfiguration = 145,
  CanViewClientNCIInformation = 146,
  CanChangeClientNCIInformation = 147,
  CanEditLanguages = 148,
  CanViewComplianceCountryRisk = 149,
  CanEditComplianceCountryRisk = 150,
  CanChangeNCIRules = 151,
  CanExportClientsModule = 152,
  CanBrowseAppTest = 153,
  CanViewAppTest = 154,
  CanExportAccessLog = 155,
  CanAddClientTag = 156,
  CanEditClientTag = 157,
  CanDeleteClientTag = 158,
  CanViewClientTag = 159,
  CanBrowseClientTags = 160,
  CanViewTaxFormTest = 161,
  CanEditLegalDocuments = 162,
  CanDeletePaymentNotes = 163,
  CanViewBackofficeNotes = 164,
  CanEditBackofficeNotes = 165,
  CanDeleteBackofficeNotes = 166,
  CanViewClientAMLData = 167,
  CanEditAmlData = 168,
  CanViewAmlRules = 169,
  CanEditAmlRules = 170,
  CanMassKycUpdate = 171,
  CanModifyClientProduct = 172,
  CanViewCorporateTest = 173,
  CanEditToggleMLM = 174,
  CanEditClientTwoFactorAuthentication = 175,
  CanManageClientsService = 190,
  CanAddExclusionFromBonusCampaign = 191,
  CanExcludeClientFromLuckyDraws = 192,
  CanViewEconomicProfileTests = 193,
  CanImpersonate = 194,
  CanBrowseIntroducingBrokers = 200,
  CanViewIntroducingBroker = 201,
  CanEditIntroducingBroker = 202,
  CanAddIntroducingBroker = 203,
  CanAssignIntroducingBrokers = 204,
  CanViewIntroducingBrokerRebate = 205,
  CanEditIntroducingBrokerRebate = 206,
  CanEditIntroducingBrokerLoyaltyPoints = 208,
  CanCalculateMultiLevelCommissionLevel = 209,
  CanRecalculateLoyaltyTiers = 210,
  CanAccumulateRebatePeriods = 211,
  CanCalculateRebatePayouts = 212,
  CanViewClientJourneyMap = 214,
  CanEditRebatePolicies = 215,
  CanViewRebatePolicies = 216,
  CanViewPayoutScheme = 217,
  CanBrowsePaymentAgents = 300,
  CanViewPaymentAgent = 301,
  CanEditPaymentAgent = 302,
  CanAddPaymentAgent = 303,
  CanEditPaymentAgentProfile = 304,
  CanAddPaymentAgentProfile = 305,
  CanDeletePaymentAgentProfile = 306,
  CanBrowseAccountGroups = 400,
  CanViewAccountGroup = 401,
  CanEditAccountGroup = 402,
  CanAddAccountGroup = 403,
  CanEditAccountGroupSettings = 404,
  CanBrowseWallets = 500,
  CanViewWallet = 501,
  CanAddWallet = 502,
  CanEditWallet = 503,
  CanViewWalletTradingAccounts = 504,
  CanViewWalletTransactions = 505,
  CanViewWalletConfiguration = 506,
  CanEditWalletConfiguration = 507,
  CanBrowseTradingAccounts = 600,
  CanViewTradingAccount = 601,
  CanEditTradingAccount = 602,
  CanAddTradingAccount = 603,
  CanEditClientIntroducingBroker = 604,
  CanBrowseDeals = 605,
  CanViewDealsSummary = 606,
  CanCalculateDeals = 607,
  CanRecalculateDeals = 608,
  CanBrowseIntroducingBrokerProfiles = 609,
  CanViewIntroducingBrokerProfile = 610,
  CanAddIntroducingBrokerProfile = 611,
  CanEditIntroducingBrokerProfile = 612,
  CanBrowseTradingAccountRestrictions = 613,
  CanViewTradingAccountRestriction = 614,
  CanAddTradingAccountRestriction = 615,
  CanDeleteTradingAccountRestriction = 616,
  CanViewTradingAccountStatistics = 617,
  CanViewTradingAccountOpenPositions = 618,
  CanViewTradingAccountPendingOrders = 619,
  CanViewTradingAccountTransactions = 620,
  CanViewTradingAccountPlatformTransactions = 621,
  CanViewWalletTransactionCalculatorResult = 622,
  CanRunWalletTransactionCalculator = 623,
  CanBrowseInstruments = 624,
  CanEditInstrument = 625,
  CanEditDemoTradingAccount = 626,
  CanEditWelcomeTradingAccount = 627,
  CanBrowseWelcomeAccounts = 628,
  CanBrowseDemoAccounts = 629,
  CanViewDemoAccounts = 630,
  CanViewWelcomeAccounts = 631,
  CanDeleteInstrument = 632,
  CanResetDemoAccountPassword = 633,
  CanResetWelcomeAccountPassword = 634,
  CanCreateSubscriptions = 635,
  CanEditSubscriptions = 636,
  CanDeleteSubscriptions = 637,
  CanViewSubscriptions = 638,
  CanUpdateMetatrader4Settings = 639,
  CanUpdateMetatrader5Settings = 640,
  CanAddFundsToDemoAccounts = 641,
  CanDeductFundsFromDemoAccounts = 642,
  CanAddFundsToWelcomeAccounts = 643,
  CanDeductFundsFromWelcomeAccounts = 644,
  CanForceCloseWelcomeAccountTrades = 645,
  CanViewBrokerageDeals = 646,
  CanEditDividendPayments = 647,
  CanUploadCsvFilesToCreateDividendPayments = 648,
  CanViewClientSubscriptions = 649,
  CanAddSubscriptionOverrides = 650,
  CanUpdateSubscriptionOverrides = 651,
  CanDeleteSubscriptionOverrides = 652,
  CanBrowseSubscriptionOverrides = 653,
  CanViewSubscriptionRequestCancellations = 654,
  CanViewCommissionPlans = 655,
  CanEditCommissionPlans = 656,
  CanDeleteCommissionPlans = 657,
  CanViewMultiTierNetwork = 658,
  CanEditSubAccountCommissionPlanGroup = 659,
  CanArchiveTradingAccounts = 660,
  CanViewTickmillCompanyPlatformTypes = 661,
  CanEditTickmillCompanyPlatformTypes = 662,
  CanAggregateDeals = 663,
  CanViewTicket = 701,
  CanEditTicket = 702,
  CanAddTicket = 703,
  CanCompleteTickets = 704,
  CanAcquireTickets = 705,
  CanAssignTickets = 706,
  CanBrowsePaymentsTickets = 707,
  CanBrowseSalesTickets = 708,
  CanBrowseBackofficeTickets = 709,
  CanCompleteClientTickets = 711,
  CanAcquireClientTickets = 712,
  CanBrowseComplianceTickets = 713,
  CanViewUserTicketStatistics = 714,
  CanViewAllUsersTicketStatistics = 715,
  CanBrowseTranslationsTickets = 716,
  CanBrowseBrokerageTickets = 717,
  CanManageTicketsService = 730,
  CanBrowseDocuments = 800,
  CanViewDocument = 801,
  CanEditDocument = 802,
  CanAddDocument = 803,
  CanLinkDocument = 804,
  CanAssociateDocument = 805,
  CanDeleteDocument = 806,
  CanAddPaymentsDocument = 807,
  CanEditPaymentsDocument = 808,
  CanDeletePaymentsDocument = 809,
  CanManageDocumentsService = 820,
  CanBrowseCrossWalletTransactions = 900,
  CanViewCrossWalletTransaction = 901,
  CanRemoveMarginBonusCredit = 903,
  CanBrowseWalletTradingAccountTransactions = 909,
  CanViewWalletTradingAccountTransaction = 910,
  CanCreateWalletTradingAccountTransaction = 912,
  CanBrowseCustomUserWalletTransactions = 914,
  CanViewCustomUserWalletTransaction = 915,
  CanAddCustomUserWalletTransaction = 917,
  CanBrowsePaymentAgentTransactions = 919,
  CanViewPaymentAgentWalletTransaction = 920,
  CanAddPaymentAgentWalletTransaction = 922,
  CanBrowseWalletDepositWithdrawalTransactions = 924,
  CanViewWalletDepositWithdrawalTransaction = 925,
  CanAddWalletDepositTransaction = 927,
  CanReverseWalletDepositWithdrawalTransaction = 929,
  CanAddWalletWithdrawalTransaction = 932,
  CanCreateTransactions = 934,
  CanTransferFromWalletToTradingAccountTransaction = 935,
  CanTransferFromTradingAccountToWalletTransaction = 936,
  CanReverseCustomUserWalletTransaction = 937,
  CanAddNegativeEquityTransactions = 938,
  CanEditTransactionStatus = 939,
  CanEditTransactions = 940,
  CanResetTradingAccountPassword = 941,
  CanUpdateTradingAccountPassword = 942,
  CanAddCrossWalletTransaction = 943,
  CanBrowseTransactions = 950,
  CanUseWorldCheckScreening = 951,
  CanViewWorldCheckResults = 952,
  CanViewDocumentAuditLog = 953,
  CanEmailDocumentStatus = 954,
  CanEmailDocumentPasswordRequest = 955,
  CanResetClientFailedLogins = 956,
  CanViewClientIdentityVerificationResults = 957,
  CanViewClientKycUpdateTests = 958,
  CanAddClientKycUpdateTests = 959,
  CanViewTradingAccountConfiguration = 960,
  CanEditTradingAccountConfiguration = 961,
  CanEditTradingAccountAutomaticClosure = 962,
  CanAddClientAppropriatenessTest = 963,
  CanBrowseIBCommissionsTransactions = 970,
  CanBrowseTradingAccountAdjustments = 971,
  CanAddTradingAccountAdjustments = 972,
  CanAddClientTaxFormTests = 975,
  CanReduceBonusTransactionReserved = 981,
  CanCreateBonusTransactions = 982,
  CanViewBonusTransactions = 983,
  CanViewBonusTypes = 984,
  CanEditBonusTypes = 985,
  CanViewBonusTypesDetails = 986,
  CanBrowseBonusTransactions = 987,
  CanResetClientPasswordResetAttempts = 988,
  CanViewFundingSummary = 989,
  CanViewPaymentProviderThresholds = 990,
  CanAddPaymentProviderThresholds = 991,
  CanEditPaymentProviderThresholds = 992,
  CanDeletePaymentProviderThresholds = 993,
  CanUploadCsvFilesToCreateTransactions = 994,
  CanViewUploadFileHistory = 995,
  CanExportTransactionsModule = 996,
  CanBrowseBulkTransactionsFileUploadHistory = 997,
  CanCreateTradingAccountBalanceConversion = 999,
  CanManageLeadsService = 1100,
  CanViewLeads = 1101,
  CanEditLeads = 1102,
  CanCreateEmailVerification = 1103,
  CanImportLeads = 1104,
  CanAddLeadNotes = 1105,
  CanEditLeadNotes = 1106,
  CanDeleteLeadNotes = 1107,
  CanBrowseLeadNotes = 1108,
  CanResetActivity = 1109,
  CanAddRestrictedEmails = 1110,
  CanBrowseRestrictedEmails = 1111,
  CanEditRestrictions = 1112,
  CanCreateLeadForClient = 1113,
  CanDeleteRestrictedEmails = 1114,
  CanAssignSglToLead = 1115,
  CanViewPaymentProviderOptions = 1201,
  CanEditPaymentProviderOptions = 1202,
  CanRequestWithdrawalEmails = 1203,
  CanDeletePaymentProviderOptions = 1204,
  CanViewBankDetails = 1205,
  CanEditBankDetails = 1206,
  CanDeleteBankDetails = 1207,
  CanCreateBankDetails = 1208,
  CanViewClientAccounts = 1209,
  CanEditClientAccounts = 1210,
  CanDeleteClientAccounts = 1211,
  CanCreateClientAccounts = 1212,
  CanManagePaymentsService = 1220,
  CanBrowseMarketingCampaigns = 1301,
  CanEditMarketingCampaigns = 1302,
  CanViewMarketingCampaigns = 1303,
  CanBrowseContestResults = 1304,
  CanViewRewards = 1305,
  CanAddOrEditRewards = 1306,
  CanBrowseBonusCampaigns = 1311,
  CanViewBonusCampaigns = 1312,
  CanEditBonusCampaigns = 1313,
  CanAddSwapFreeOption = 1314,
  CanEditSwapFreeOption = 1315,
  CanBrowseRateMarkups = 1401,
  CanCreateMarkup = 1402,
  CanEditMarkup = 1403,
  CanDeleteMarkup = 1404,
  CanBrowseExchangeRates = 1501,
  CanBrowseTickmillCompanyReferrals = 1601,
  CanCreateTickmillCompanyReferrals = 1602,
  CanDeleteTickmillCompanyReferrals = 1603,
  CanCreateIntroducingBrokerReferralRestriction = 1604,
  CanDeleteIntroducingBrokerReferralRestriction = 1605,
  CanGenerateSGLCode = 1651,
  CanGenerateSGLUrl = 1652,
  CanBrowseLossPercentage = 1701,
  CanEditLossPercentage = 1702,
  CanDeleteLossPercentage = 1703,
  CanCreateAppropriatenessTest = 1704,
  CanBrowseAppropriatenessTest = 1705,
  CanEditAppropriatenessTest = 1706,
  CanDeleteAppropriatenessTest = 1707,
  CanPublishAppropriatenessTest = 1708,
  CanCreateEconomicProfileTest = 1709,
  CanBrowseEconomicProfileTest = 1710,
  CanEditEconomicProfileTest = 1711,
  CanDeleteEconomicProfileTest = 1712,
  CanPublishEconomicProfileTest = 1713,
  CanBrowsePromoMaterials = 1801,
  CanCreatePromoMaterial = 1802,
  CanEditPromoMaterial = 1803,
  CanDeletePromoMaterial = 1804,
  CanViewPromoMaterial = 1805,
  CanSendReferralCode = 1806,
  CanViewReferralMaterials = 1821,
  CanEditReferralMaterials = 1822,
  CanViewTickmillPublicDomain = 1850,
  CanEditNotifications = 1903,
  CanViewNotifications = 1905,
  CanManageCAIntegrationService = 1906,
  CanSendTestEmails = 1907,
  CanViewContactDetails = 1908,
  CanEditContactDetails = 1909,
  CanExecuteMarketingEndpoints = 1910,
  CanPreviewEmails = 1911,
  CanBrowsePaymentProviders = 2000,
  CanEditPaymentProviders = 2001,
  CanBrowseBulkWithdrawals = 2002,
  CanBrowsePspGroups = 2003,
  CanEditPspGroups = 2004,
  CanDeletePspGroups = 2005,
  CanBrowseAffiliates = 2100,
  CanViewAffiliates = 2101,
  CanEditAffiliates = 2102,
  CanAssignAffiliates = 2103,
  CanBrowseFeatureFlags = 3000,
  CanEditFeatureFlags = 3001,
  CanBrowseVersions = 3002,
  CanEditVersions = 3003,
  CanBrowsePlatformVersions = 3004,
  CanEditPlatformVersions = 3005,
  CanBrowseInterestRatesConfig = 4000,
  CanEditInterestRatesConfig = 4001,
  CanEditInterestRatesRestriction = 4002,
  CanBrowseClientsInterestRates = 4003,
  CanUpdateServerSessions = 5000,
  CanBrowsePlatformLinks = 6000,
  CanCreatePlatformLinks = 6001,
  CanEditPlatformLinks = 6002,
  CanViewPlatformLinksAuditLog = 6003,
  CanManageOperationsService = 7000,
  CanBrowseJobSchedulers = 7001,
  CanCreateUpdateJobSchedulers = 7002,
  CanBrowseJobInstances = 7003,
  CanCreateUpdateJobInstances = 7004,
  CanBrowseDashboardsLayouts = 8000,
  CanCreateDashboardsLayouts = 8001,
  CanEditDashboardsLayouts = 8002,
  CanDeleteDashboardsLayouts = 8003,
  CanViewPAMDashboard = 8004,
  CanCreate3DSSession = 9000,
  CanRead3DSSession = 9001,
  CanCreateProxy = 9002,
  CanCreateTokenIntent = 9003,
  CanCreateToken = 9004,
  CanRegisterTokenAttempt = 9005,
  CanMakeExternalPayment = 9006,
  CanBrowseTokenizedCardDetails = 9007,
  CanEditTokenizedCardDetails = 9008,
  CanViewMLWithdrawalAutomationSettings = 10000,
  CanEditMLWithdrawalAutomationSettings = 10001,
  CanAddBulkRestrictions = 12000,
}
